let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8QK5x")).then(() => parcelRequire('k9Nyn'));